import { useState } from "react";

import Intro from "../components/Intro";
import { useNavigate } from "react-router-dom";
import CarouselRelative from "../components/CarouselRelative";
import { mixpanelInstance } from "../../shared/utils/mixpanel";

const OnboardingRelative = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(1);

  if (step === 0)
    return (
      <Intro
        next={() => {
          mixpanelInstance.track("ED - OF - Decouvrir");
          setStep(step + 1);
        }}
      />
    );

  if (step === 1)
    return (
      <CarouselRelative
        next={() => {
          mixpanelInstance.track("ED - OF - Fin Carrousel");
          navigate("/v2/home");
        }}
      />
    );
};

export default OnboardingRelative;
